import NotificationEmailAutocomplete from '@/components/views/SettingsView/EmailNotifications/NotificationAutocomplete';
import UserNotification from '@/components/views/SettingsView/EmailNotifications/UserNotification';
import { FormControl, FormHelperText, FormLabel, Stack, useTheme } from '@mui/material';
import React from 'react';

const CompleteDealNotification = ({ type, label }) => {
	const theme = useTheme();
	return (
		<Stack spacing={2}>
			<FormControl>
				<FormLabel variant='body2'>{`${label}s`}</FormLabel>
				<UserNotification type={type} action={'complete'} />
			</FormControl>

			<FormControl>
				<FormLabel
					sx={{
						color: theme.palette.text.secondary,
						fontWeight: 400,
						fontSize: '0.75rem',
					}}
				>
					{'Other emails'}
				</FormLabel>
				<NotificationEmailAutocomplete
					type={type}
					action={'complete'}
					id={`${type}-emails`}
				/>
				<FormHelperText>{`These email addresses will receive an email when a ${type} is completed`}</FormHelperText>
			</FormControl>
		</Stack>
	);
};

export default CompleteDealNotification;
